import React from "react";
import Typewriter from "typewriter-effect";
import { useTranslation } from "../../i18n";

function Type() {
  const { t, language } = useTranslation();
  const strings = t("home.typewriter");

  return (
    <Typewriter
      key={language}
      options={{
        strings: Array.isArray(strings) ? strings : [],
        autoStart: true,
        loop: true,
        deleteSpeed: 50,
      }}
    />
  );
}

export default Type;
